import DataManager from "./DataManager";
import config from "../content/config";

const getSQLFilterForUnionOfStates = (selectedUSStatesToFilterWithin) => {
	return selectedUSStatesToFilterWithin.reduce((_filterStr, stateName, i) => {
		return `${_filterStr}${i === 0 ? '' : ' OR'} st_name = '${stateName}'`
	}, '')
}
export const getMinMaxQueryForFields = (fieldNames, cartoLayerId, selectedUSStatesToFilterWithin) => {
	const selectStatement = fieldNames
		.map(numericField => `MIN(${numericField}) as min_${numericField}, MAX(${numericField}) as max_${numericField}`)
		.join(',')
	const sqlFilterForUnionOfStates = getSQLFilterForUnionOfStates(selectedUSStatesToFilterWithin)
	const sqlFilterToApplyToAllACSLayers = DataManager.sqlFilterToApplyToAllACSLayers() && `AND ${DataManager.sqlFilterToApplyToAllACSLayers()}`
	return {query: `SELECT ${selectStatement} FROM "${config.CARTO_USER}".${cartoLayerId} WHERE ${sqlFilterForUnionOfStates} ${sqlFilterToApplyToAllACSLayers}`}
}
